jQuery(function($) {

    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
    

    // Hide selectors if we only have 1 variant and its title contains 'Default'.
    

    // Check if the description contains --- and if yes, split the description
    var productDescription = $(".hidden-description").html();
    var splitDescription = productDescription.split("---");

    if (splitDescription.length > 2){
      $(".normal-product-view").remove();
      $(".enhanced-product-view").show();
    } else {
      $(".enhanced-product-view").remove();
    };

    $(".product-short-description").html(splitDescription[0]);
    $(".product-description").html(splitDescription[1].split("===")[0]);

    // If there is a content in the product description, show the wrapper
    if($(".product-description").text().length != 0){
      $(".the-description").show();
    }

    // Show the enhanced part if there is more than one split
    if ($(".enhanced-product-view").length > 0){
      $(".enhanced-product-view .title").html(splitDescription[2]); // Place the heading
      if (splitDescription.length > 3 ){
        var infoOneTitle = splitDescription[3].match(/<h(.)>.*?<\/h\1>/g); // Find the h3
        var infoOneContent = splitDescription[3].match(/<p>.*?<\/p>/g); // Find the p
        var infoOneImage = $(splitDescription[3]).find("img").attr("src"); // Find the img

        $(".first-info").css("display", "table");
        $(".first-info .content").html(infoOneTitle + infoOneContent[0]);
        $(".first-info .image").css("background-image", "url("+infoOneImage+")");
      }

      if (splitDescription.length > 4 ){
        var infoTwoTitle = splitDescription[4].match(/<h(.)>.*?<\/h\1>/g); // Find the h3
        var infoTwoContent = splitDescription[4].match(/<p>.*?<\/p>/g); // Find the p
        var infoTwoImage = $(splitDescription[4]).find("img").attr("src"); // Find the img

        $(".second-info").css("display", "table");
        $(".second-info .content").html(infoTwoTitle + infoTwoContent[0]);
        $(".second-info .image").css("background-image", "url("+infoTwoImage+")");
      }

      if (splitDescription.length > 5 ){
        var infoThreeTitle = splitDescription[5].match(/<h(.)>.*?<\/h\1>/g); // Find the h3
        var infoThreeContent = splitDescription[5].match(/<p>.*?<\/p>/g); // Find the p
        var infoThreeImage = $(splitDescription[5]).find("img").attr("src"); // Find the img

        $(".third-info").css("display", "table");
        $(".third-info .content").html(infoThreeTitle + infoThreeContent[0]);
        $(".third-info .image").css("background-image", "url("+infoThreeImage+")");
      }
    }


    // Set read more toggle to the description text
    if( $(".product-description").length != 0 && $(".product-description").text().length > 150){
      $(".product-description").parent().append("<button class='toggle-description'>+ Read more</button>");
      $(".product-description").append('<span class="gradient-mask"></span>');
      $("body").on("click", ".toggle-description", function(){
        $(".product-description").toggleClass("open");
        if ($(".toggle-description").text() == "+ Read more"){
          $(".toggle-description").text("- Show less");
        } else {
          $(".toggle-description").text("+ Read more");
        }
      });
    }

    // Set the minimum height of the product single to equal to the slider
    setInterval(function(){
      $(".product-single").css("min-height", $(".product-slider").outerHeight());
    }, 100);

    // Check if the description contains === , if yes split it (This is for the Video)
    if ($(".hidden-description").text().indexOf("===") != -1){

      $(".video").show();
    
      var splitDescriptionVideo = productDescription.split("===");
      $("body").append('<div class="the-video-url">'+splitDescriptionVideo[1]+'</div>');
      
      var theVideo = $(".the-video-url").text();

      // get the JSON data from a the ajax call
      var videoIframe;

      jQuery.ajax({
        type: 'GET',
        contentType: "application/json",
        jsonpCallback: 'videoData',
        dataType: 'jsonp',
        url: 'https://noembed.com/embed?url='+theVideo+'&callback=videoData',
        success: function(data){
          videoIframe = data.html
        },
        async: false
      });

      $(".video").on("click", function(){
        $("body").append('<div class="the-video-wrapper"><div class="the-video"><img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0ZGRkZGRjt9PC9zdHlsZT48cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTIsMkM2LjUsMiwyLDYuNSwyLDEyczQuNSwxMCwxMCwxMHMxMC00LjUsMTAtMTBTMTcuNSwyLDEyLDJ6IE0xNi45LDE1LjVsLTEuNCwxLjRMMTIsMTMuNGwtMy41LDMuNWwtMS40LTEuNGwzLjUtMy41TDcuMSw4LjVsMS40LTEuNGwzLjUsMy41bDMuNS0zLjVsMS40LDEuNEwxMy40LDEyTDE2LjksMTUuNXoiLz48L3N2Zz4=" class="close-video" />'+videoIframe+'</div></div>');

        var showVideo = function(){
          TweenMax.fromTo('.the-video', 0.4,{
            scale: 0
          },
          {
            scale: 1,
            opacity: 1,
            ease: Elastic.easeOut.config(1, 1)
          });
        }

        TweenMax.to('.the-video-wrapper', 0.2,{
          opacity: 1,
          onComplete: showVideo
        });

      });

      $("body").on("click", ".close-video", function(){
        var removeVideoWrapper = function(){
          $(".the-video-wrapper").remove();
        }

        var hideVideoWrapper = function(){
          TweenMax.to('.the-video-wrapper', 0.2,{
            opacity: 0,
            onComplete: removeVideoWrapper
          });
        }

        TweenMax.fromTo('.the-video', 0.5,{
            scale: 1
          },
          {
            scale: 0,
            opacity: 0,
            ease: Elastic.easeOut.config(1, 1),
            onComplete: hideVideoWrapper
          });
      });
    } else {
      $(".video").remove();
    }

    // Product Thumbs
//     $("#ProductThumbs").owlCarousel({
//       itemsCustom: [[0, 1], [869, 6]],
//       paginationNumbers: true
//     });

//     $(".owl-item:first-child").addClass("active");
//     $(".owl-item").on("click", function(){
//       $(".owl-item").removeClass("active");
//       $(this).addClass("active");
//     });

    // Check when the images are loaded and attach the slider to them
    var imagesLoaded = false;
    var imagesLoop = setInterval(function(){
      if ($(".collection .grid__item:nth-child(1) img").attr("src")){
        console.l
        imagesLoaded = true;
      }
      if (imagesLoaded == true){
        clearInterval(imagesLoop);
        // Related Products
//         $(".featured-collection").owlCarousel({
//           items: 2,
//           itemsCustom: [[550,2],[650,3],[1024,4]],
//           responsive: true,
//           responsiveRefreshRate: 100,
//           responsiveBaseWidth: window,
//           lazyLoad: true
//         });

      }
    }, 100);       

    // Chane the font of the "Back in Stock" plugin
    $(".add-to-basket-panel").on("click", "#BIS_trigger", function(){
      var bisIframe = document.getElementById('BIS_frame');
      var innerDoc = bisIframe.contentDocument || bisIframe.contentWindow.document;
      bisH3 = innerDoc.getElementsByTagName("H3");
      bisH4 = innerDoc.getElementsByTagName("H4");
      bisP = innerDoc.getElementsByTagName("P");
      bisButton = innerDoc.getElementsByTagName("button");

      // Find the head and append the fonts
      var $head = $("#BIS_frame").contents().find("head");

      if($head.find("link").length < 1){
        $head.append("<link type='text/css' rel='stylesheet' href='//fast.fonts.net/cssapi/27ea47ca-ce25-4b87-bd8c-f583d7491d72.css'/>");
        $head.append("<style>h3, h4, button { font-family: 'ITC Avant Garde Gothic W01 Bd';} p, input, select {font-family: 'AvenirNextLTW01-Regular'} .close{color: #fe6417;} button{font-size: 16px;} #container {background-color: #f2f2f2;} @media screen and (min-width: 768px) and (max-width: 1023px){#BISModal {margin-top: 68px;}}</style>");
      }
    });    

  });